import { MaskLine, FadeUp } from "./Reveal";

const FAQS = [
  ["What does a vineyard management company do?", "A vineyard management company farms your vineyard year-round: pruning, canopy work, pest and disease programs, irrigation, labor, and harvest. Vinedresser manages estates across Napa and Sonoma and logs every activity in VineOps, so owners always have a current, complete record of their ranch."],
  ["How much does vineyard management cost in Napa or Sonoma?", "Costs depend on acreage, terrain, varietal, and farming program. After a site visit, we prepare an annual farming plan with a per-acre budget, then track actual costs against it in VineOps throughout the season."],
  ["I'm evaluating a vineyard property in Napa or Sonoma. Can you assess it before I buy?", "Yes. We perform acquisition due diligence for vineyard buyers: vine age and health, soils, water supply, equipment, and true farming costs, so you understand the property before closing."],
  ["How do I see what is happening on my ranch?", "Through VineOps, our client portal. Spray records, irrigation schedules, phenology, yield estimates, labor, and budgets are all logged the day the work happens and available to clients at any time."],
  ["Do you develop or replant vineyards?", "Yes. We handle site preparation, layout, rootstock and clone selection, and establishment farming through the first commercial crop for new and replanted vineyards in Napa and Sonoma."],
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-28 md:py-40 bg-[#F3EFE6] hairline-t">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 md:gap-10">
      <div className="md:col-span-4">
        <FadeUp>
          <p className="text-[11px] tracking-[0.32em] uppercase text-[#B89B67] font-semibold mb-10">Common Questions</p>
        </FadeUp>
        <h2 className="font-display font-light text-[#1A3626] text-5xl md:text-6xl leading-[1.02] tracking-tight">
          <MaskLine delay={0.1}>Answers,</MaskLine>
          <MaskLine delay={0.22}>up front.</MaskLine>
        </h2>
      </div>
      <div className="md:col-span-8">
        {FAQS.map(([q, a], i) => (
          <FadeUp key={q} delay={i * 0.06}>
            <div data-testid={`faq-item-${i + 1}`} className="hairline-t py-8 md:py-10">
              <h3 className="font-display font-light text-2xl md:text-[1.7rem] text-[#1A3626] leading-snug max-w-[34ch]">{q}</h3>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-[#2C2926]/70 max-w-[64ch]">{a}</p>
            </div>
          </FadeUp>
        ))}
        <div className="hairline-t" />
      </div>
    </div>
  </section>
);
